<template>
  <div class="mb-2">
    <label :for="id" class="form-label fw-bold d-block text-start">{{ label }}</label>
    <div class="input-group">
      <span class="input-group-text" v-if="icon">
        <i :class="icon"></i>
      </span>
      <input
        :type="type"
        :id="id"
        :placeholder="placeholder"
        class="form-control"
        :value="modelValue"
        @input="handleInput"
        :required="required || false"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  modelValue: string;
  label?: string; // Optional prop
  type?: string;
  id: string;
  placeholder?: string;
  icon?: string;
  required?: boolean;
}

// Define props
defineProps<Props>();

// Define emits
const emit = defineEmits<{
  (event: 'update:modelValue', value: string): void;
}>();

// Handle input
function handleInput(event: Event) {
  const target = event.target as HTMLInputElement;
  if (target) {
    const value = target.value;
    emit('update:modelValue', value);
  }
}
</script>


<style scoped>
.form-label {
  margin-bottom: 0.4rem; /* Compact spacing below the label */
}

.mb-2 {
  margin-bottom: 1rem; /* Adjust spacing between fields */
}

.input-group-text {
  padding: 0.4rem 0.75rem; /* Reduce padding for compactness */
}

.input-group .form-control {
  padding: 0.4rem 0.75rem; /* Compact input field height */
}
</style>
